exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tips {\r\n  color: #ccc;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/plus/agent/setting/part/Words.vue"],"names":[],"mappings":";AACA;EACE,YAAY;CACb","file":"Words.vue","sourcesContent":["\n.tips {\r\n  color: #ccc;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b7285ee","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/plus/agent/setting/part/Words.vue
// module id = 7f59
// module chunks = 0